export function isValidParam<T>(param: T | undefined | null): param is T {
  if (param === undefined || param === null) return false;

  if (typeof param === 'string') {
    return param.trim() !== '';
  }

  return true;
}
